import { CreateDataSource } from '@/features/dataSources/components/createDataSource/CreateDataSource';
import { resetUploadStatus } from '@/features/fileUploading/fileUploadingSlice';
import { showToast } from '@/features/toasts/toastsSlice';
import { useModalContext } from '@/hooks/useModalContext';
import { DataSource, DataSourceIDEnum } from '@/models/dataSource';
import { ToastType } from '@/models/toast';
import { useAppDispatch } from '@/reducers';
import { useTranslation } from 'react-i18next';
import { FISCAL_CODE_TRAIT_ID } from './constants';

/**
 * Opens the standard CSV datasource wizard (fiscal code mapping enforced).
 * On success, the server auto-creates a matching audience on first activation
 * (name = datasource name, matching trait = fiscal code, with NOT-NULL rule).
 */
export const useImportList = (onDone?: () => void) => {
  const { t } = useTranslation('comuni');
  const { openModal } = useModalContext();
  const dispatch = useAppDispatch();

  const handleCreated = (dataSource: DataSource) => {
    if (!dataSource?.id) {
      dispatch(showToast({ type: ToastType.ERROR, title: t('import.audienceError') }));
      return;
    }
    dispatch(showToast({ type: ToastType.SUCCESS, title: t('import.success', { name: dataSource.name }) }));
    onDone?.();
  };

  return () => {
    dispatch(resetUploadStatus());
    openModal({
      renderContent: CreateDataSource,
      renderContentProps: {
        dataSourceId: DataSourceIDEnum.CsvFile,
        requiredMapping: { traitIds: [FISCAL_CODE_TRAIT_ID], tooltip: t('import.mapFiscalCode') },
        autoAudienceTraitId: FISCAL_CODE_TRAIT_ID,
        onSuccess: handleCreated,
      },
      fullHeight: true,
      fullWidth: true,
    });
  };
};
